import { xSequentialFillFromStep } from "./xSequentialFillFromStep.js";
export function xSequentialFillFromTo(parameters, options = {}) {
    const { from, to, size } = parameters;
    const step = size <= 1 ? 0 : (to - from) / (size - 1);
    return xSequentialFillFromStep({ from, step, size }, options);
}
//# sourceMappingURL=xSequentialFillFromTo.js.map